import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Button,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import apiRequest from "apiRequest"; // Ensure this path is correct

function CategoryTable({
  categories,
  isDragging,
  handleDragEnd,
  handleDragStart,
  handleStatusToggle,
  handleEdit,
  handleDeleteClick, // Renamed to avoid confusion with internal handleDelete in main component
}) {
  return (
    <TableContainer component={Paper} style={{ marginTop: "1px" }}>
      <DragDropContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
        <Table>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Sequence</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Agreement</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
          <Droppable droppableId="categories">
            {(provided) => (
              <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                {categories.map((category, index) => (
                  <Draggable key={category.id} draggableId={String(category.id)} index={index}>
                    {(provided) => (
                      <TableRow
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          backgroundColor: isDragging ? 'rgba(0, 0, 0, 0.05)' : 'inherit',
                        }}
                      >
                        <TableCell>
                          <span style={{ cursor: 'move' }}>☰ {category.sequence}</span>
                        </TableCell>
                        <TableCell style={{ color: category.color || 'rgba(0, 0, 0, 0.04)' }}>
                          {category.name_en + ' / ' + category.name_fr}
                        </TableCell>
                        <TableCell>
                          <img
                            src={`${apiRequest.BASE_URL}/${category.image}`}
                            alt={category.name_en}
                            style={{ width: "100px", height: "auto" }}
                          />
                        </TableCell>
                        <TableCell>
                          {category.agreement_template_id || "N/A"}
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={category.status === "active"}
                            onChange={() => handleStatusToggle(category.id, category.status)}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          <Button
                            onClick={() => handleEdit(category)}
                            color="primary"
                            size="small"
                          >
                            Edit
                          </Button>
                          <Button
                            onClick={() => handleDeleteClick(category.id)}
                            color="error"
                            size="small"
                            style={{ marginLeft: "8px" }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
    </TableContainer>
  );
}

export default CategoryTable;